function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { BrowserClient, Hub, ErrorBoundary } from '@sentry/react';
import { merge } from 'lodash';
import { ThemeProvider } from 'styled-components';
import { useConfigAtomValues, useDataAtomValues } from '../state';
import i18n, { initI18n } from './i18n';
import defaultTheme from './theme';
import useAuth from './useAuth';
var SENTRY_DSN = 'https://04d06b1dbd9145b2abaadad64053dff0@sentry-new.myshopline.com/437';
function withI18nAndTheme(WrapperComponent) {
  var Comp = function Comp(props) {
    // fixme: any
    var _ref = props,
      onAuthError = _ref.onAuthError,
      accessToken = _ref.accessToken;
    // FIXME: 因为props有可能会有拿不到实际调用方传入的参数，故将onAuthError设置到window
    if (!!onAuthError) {
      window.SETTLEMENT_SDK_AUTH_CALLBACK = onAuthError;
    }
    useAuth(accessToken, props, useConfigAtomValues());
    // 读取使用方通过「useConfigAtomUpdate」修改的状态configAtom。
    // etc：shopline-admin-subscription/src/pages/PlanSettlement/index.tsx
    // 具体到：setConfig 这个方法
    var config = useConfigAtomValues();
    var _config$props = _objectSpread(_objectSpread({}, config), props),
      appId = _config$props.appId,
      bizType = _config$props.bizType,
      subBizType = _config$props.subBizType,
      merchantNo = _config$props.merchantNo,
      email = _config$props.email,
      phone = _config$props.phone,
      returnUrl = _config$props.returnUrl,
      env = _config$props.env,
      language = _config$props.language,
      theme = _config$props.theme;
    var hubRef = useRef();
    // 由使用方提供的
    window.SETTLEMENT_SDK_ENV = env;

    // 判断业务方是否开启了超时退款功能
    var _useDataAtomValues = useDataAtomValues(),
      payRetryTime = _useDataAtomValues.payRetryTime;
    if (!hubRef.current) {
      /** Sentry初始化 */
      var client = new BrowserClient({
        dsn: SENTRY_DSN,
        environment: env
      });
      hubRef.current = new Hub(client);
      hubRef.current.setUser({
        appId: appId,
        bizType: bizType,
        subBizType: subBizType,
        merchantNo: merchantNo,
        phone: phone,
        email: email
      });
      hubRef.current.setExtra('ExtraInfo', {
        returnUrl: returnUrl,
        env: env
      });
    }
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoadedLang = _useState2[0],
      setIsLoadedLang = _useState2[1];

    // 多语言加载完毕，展示结算页
    useEffect(function () {
      if (!env) return;
      initI18n(env || 'prod').finally(function () {
        setIsLoadedLang(true);
      });
    }, [env]);

    // 切换多语言-
    useEffect(function () {
      // 等多语言init完成后再去切换语种，否则可能会出现切换的语种会被默认语种覆盖的情况
      if (isLoadedLang) {
        i18n.changeLanguage(language || 'en');
      }
    }, [language, isLoadedLang]);
    var finalizeTheme = useMemo(function () {
      // 若用户开启了超时付款功能，替换重新刷新的颜色
      return payRetryTime ? merge({}, defaultTheme, theme, {
        highlightColor: '#393df7'
      }) : merge({}, defaultTheme, theme);
    }, [theme]);
    if (!isLoadedLang) {
      return null;
    }
    var errorBoundaryProps = {
      onError: function onError(err) {
        hubRef.current.captureException(err);
      }
    };
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: finalizeTheme
    }, /*#__PURE__*/React.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React.createElement(WrapperComponent, _extends({}, props, {
      theme: finalizeTheme,
      sentryHub: hubRef.current
    }))));
  };
  return Comp;
}
export default withI18nAndTheme;